<template>
  <i v-on="$listeners" class="app-icon" :class="icon"></i>
</template>

<script>
export default {
  name: 'AppIcon',

  props: {
    icon: {
      type: String,
      default: 'far fa-user',
    },
  },
}
</script>

<style scoped>
.app-icon {
  color: inherit;
}
</style>
